import { motion } from 'framer-motion';
import { STORY } from './data';
export default function Story() {
  return (
    <div className="bg-[#F8E6DC] text-[#7A4A3F] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-dashed border-[#B89C5C]"><p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#A8B89A] mb-3">— Page II / Our story · 2018 — 2026</p><h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95] text-center">Eight years,<br />four chapters.</h1></section>
      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-14 space-y-12">
        {STORY.map((s, i) => (
          <motion.article key={s.yr} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className={`grid lg:grid-cols-[160px_1fr] gap-8 items-baseline ${i % 2 ? 'lg:text-right' : ''}`}>
            <p className="font-serif italic text-[80px] leading-[0.85] text-[#B89C5C]">{s.yr}</p>
            <div>
              <h2 className="font-serif italic text-3xl lg:text-4xl text-[#7A4A3F]">{s.t}</h2>
              <p className="font-serif text-base text-[#7A4A3F]/65 mt-3 leading-[1.7] max-w-xl" dangerouslySetInnerHTML={{ __html: s.d }} />
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
